module.exports = __webpack_public_path__ + "img/logo.938f1d04.svg";